
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Getter, Mutation, Action } from "vuex-class";
import { mapState } from "vuex";

@Component({
  components: {}
})
export default class Error extends Vue {
  @Getter("error") error: any;
  @Action("setError") setError: any;
  created() {
    if (this.$route.params.errorcode)
      this.setError(this.$route.params.errorcode);
  }
}
